module.exports = __webpack_public_path__ + "af7398f3281863944d779a77ea6354df.svg";